module.exports = __webpack_public_path__ + "img/3_56.3fb48c8b.png";